import H5Modal from '../H5Modal/H5Modal'
import { useCryptoPackageModal } from './CryptoPackageModalProvider'
import { CryptoPackageModalHeader } from './CryptoPackageModalHeader'
import { CryptoPackageModalItems } from './CryptoPackageModalItems'
import { CryptoPackageModalFooter } from './CryptoPackageModalFooter'

import classes from './styles/cryptoPackageModal.module.scss'

export const CryptoPackageModal = () => {
  const { showPackageModal, handleCloseCryptoPackageModal } = useCryptoPackageModal()

  return (
    <H5Modal
      showClose
      closeIconDesign="overlay"
      show={showPackageModal}
      onHide={handleCloseCryptoPackageModal}
      className={classes.cryptoPackageModal}
    >
      <CryptoPackageModalHeader />
      <CryptoPackageModalItems />
      <CryptoPackageModalFooter />
    </H5Modal>
  )
}
